import React, { useContext } from "react";
import ButtonElement from "./ButtonElement";
import { ShowFrontEndContext } from "../types";
import { useTranslation } from "react-i18next";

interface props {
  setIsHidden: any
}

const MyLink: React.FC<props> = ({setIsHidden}) => {
  const { LegalRegTextRef, HomePageRef, InstructionRef, ComplaintRef } = useContext(ShowFrontEndContext);

  const scrollToHomePageRef = () => {
    if (HomePageRef?.current) {
      HomePageRef.current?.scrollIntoView({ behavior: 'smooth' });
      setIsHidden()
    }
  };

  const scrollToLegalRegText = () => {
    if (LegalRegTextRef?.current) {
      LegalRegTextRef.current?.scrollIntoView({ behavior: 'smooth' });
      setIsHidden()
    }
  };

  const scrollToInstructionRef = () => {
    if (InstructionRef?.current) {
      InstructionRef.current?.scrollIntoView({ behavior: 'smooth' });
      setIsHidden()
    }
  };

  const scrollToComplaintRef = () => {
    if (ComplaintRef?.current) {
      ComplaintRef.current?.scrollIntoView({ behavior: 'smooth' });
      setIsHidden()
    }
  };

  const { t } = useTranslation()

  return (
    <div className="space-y-4 md:space-y-0 flex flex-col md:flex-row gap-4 justify-center items-center">
      {/* Home link */}
      <ButtonElement
        img={<img className="w-6 h-6" src="/assets/images/home.png" alt="home" />}
        name={t("Page d'accueil")}
        onClick={scrollToHomePageRef}
        className="hover:bg-main hover:text-white p-4 rounded-lg transition-all duration-300 w-full md:w-auto"
      />

      {/* Legal and regulatory text link */}
      <ButtonElement
        img={<img className="w-6 h-6" src="/assets/images/LegalAndRegText.png" alt="LegalAndRegText" />}
        name={t("Textes Juridiques et Réglementaires")}
        onClick={scrollToLegalRegText}
        className="hover:bg-main hover:text-white p-4 rounded-lg transition-all duration-300 w-full md:w-auto"
      />

      {/* Instructions link */}
      <ButtonElement
        img={<img className="w-6 h-6" src="/assets/images/instruction.png" alt="instruction" />}
        name={t("Instructions de l'ONMDM")}
        onClick={scrollToInstructionRef}
        className="hover:bg-main hover:text-white p-4 rounded-lg transition-all duration-300 w-full md:w-auto"
      />

      {/* Complaint link */}
      <ButtonElement
        img={<img className="w-6 h-6" src="/assets/images/complaint.png" alt="complaint" />}
        name={t("Déposez Votre Plainte")}
        onClick={scrollToComplaintRef}
        className="hover:bg-main hover:text-white p-4 rounded-lg transition-all duration-300 w-full md:w-auto"
      />
    </div>
  );
};

export default MyLink;
